module.exports = __webpack_public_path__ + "static/media/NG.bc113403.svg";